import { create } from "zustand";
export var veiculoStore = create(function (set) { return ({
    setVeiculo: function (veiculo) {
        return set(function () { return ({ veiculo: veiculo }); });
    },
}); });
